import { KeyCodeToKey, ShortcutsCategories, SpecKeys } from './Shortcuts.types'
import { isMacOS } from '../../util/general'

type ShortcutKeyMap = {
    [key: string]: string
}

export const getShortcutKeysMap = (): Record<string, Record<string, string>> => {
    const shortcuts = isMacOS() ? macShortcuts : windowsShortcuts

    const alphabetKeys = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    alphabetKeys.split('').forEach(key => {
        shortcuts[ShortcutsCategories.SECURITY_SEARCH][key] = key
    })

    return shortcuts
}

export enum GlobalShortcutsKeyName {
    openCloseTradePanel = 'openCloseTradePanel',
    placeMarketOrderBuy = 'placeMarketOrderBuy',
    placeMarketOrderSell = 'placeMarketOrderSell',
    placeLimitOrderBuy = 'placeLimitOrderBuy',
    placeLimitOrderSell = 'placeLimitOrderSell',
}

export enum ChartSettingsShortcutsKeyName {
    zoomIn = 'zoomIn',
    zoomOut = 'zoomOut',
    moveChartLeft = 'moveChartLeft',
    moveChartRight = 'moveChartRight',
    splitHorizontal = 'splitHorizontal',
    splitVertical = 'splitVertical',
    deleteCurrentWidget = 'deleteCurrentWidget',
}

export enum ScreenerScreenMenuShortcutsKeyName {
    createNewScreen = 'createNewScreen',
    saveScreen = 'saveScreen',
    saveAsScreen = 'saveAsScreen',
    discardScreenChanges = 'discardScreenChanges',
    exportScreen = 'exportScreen',
    renameScreen = 'renameScreen',
}

export enum WatchlistShortcutsKeyName {
    addToWatchlist = 'addToWatchlist',
}
export enum SecritySearchShortcuts {
    securitySearch = 'securitySearch',
    quickSearch="quickSearch"

}

export enum ChartTypeShortcutsKeyName {
    openChartTypeMenu = 'openChartTypeMenu',
}

export enum AlertDialogShortcutsKeyName {
    openAlertDialog = 'openAlertDialog',
}

export enum IndicatorDialogShortcutsKeyName {
    openIndicatorDialog = 'openIndicatorDialog',
}

export enum ChartReplayShortcutsKeyName {
    openCloseChartReplayDialog = 'openCloseChartReplayDialog',
}

export enum MultiPaneMenuShortcutsKeyName {
    openMultiPaneMenu = 'openMultiPaneMenu',
    saveLayout = 'saveLayout',
}

export enum SaveMenuShortcutsKeyName {
    openSaveMenu = 'openSaveMenu',
    saveLayout = 'saveLayout',
}

export enum ChartShortcutsKeyName {
    showHideFullScreen = 'showHideFullScreen',
    resetChartView = 'resetChartView',
    showPlusButtonOnCursor = 'showPlusButtonOnCursor',
    scrollToRecentBar = 'scrollToRecentBar',
}

export enum ChartDurationShortcutKeyName {
    openChartDuration = 'openChartDuration',
}

export enum CustomTimeBucketShortcutsKeyName {
    openCustomTimeBucketIntervalDialog = 'openCustomTimeBucketIntervalDialog',
}

export enum QuickWidgetShortcutsKeyName {
    showHideQuickWidgets = 'showHideQuickWidgets',
    openQuickWidgetMarketDepth = 'openQuickWidgetMarketDepth',
    openQuickWidgetOrders = 'openQuickWidgetOrders',
    openQuickWidgetPositions = 'openQuickWidgetPositions',
    openQuickTradeWidget = 'openQuickTradeWidget'
}

export const macShortcuts: Record<string, ShortcutKeyMap> = {
    [ShortcutsCategories.GLOBAL]: {
        // [GlobalShortcutsKeyName.openCloseTradePanel]: `${SpecKeys.SHIFT}+T`,
        [GlobalShortcutsKeyName.placeMarketOrderBuy]: `${SpecKeys.SHIFT}+B`,
        [GlobalShortcutsKeyName.placeMarketOrderSell]: `${SpecKeys.SHIFT}+S`,
        [GlobalShortcutsKeyName.placeLimitOrderBuy]: `${SpecKeys.SHIFT}+${SpecKeys.ALT}+B`,
        [GlobalShortcutsKeyName.placeLimitOrderSell]: `${SpecKeys.SHIFT}+${SpecKeys.ALT}+S`
    },
    [ShortcutsCategories.ALERT_DIALOG]: {
        [AlertDialogShortcutsKeyName.openAlertDialog]: `${SpecKeys.ALT}+A`
    },
    [ShortcutsCategories.INDICATOR_DIALOG]: {
        [IndicatorDialogShortcutsKeyName.openIndicatorDialog]: '/'
    },
    [ShortcutsCategories.MULTI_PANE_MENU]: {
        [MultiPaneMenuShortcutsKeyName.openMultiPaneMenu]: '.',
        [MultiPaneMenuShortcutsKeyName.saveLayout]: `${SpecKeys.META}+S`
    },
    [ShortcutsCategories.SAVE_MENU]: {
        [SaveMenuShortcutsKeyName.openSaveMenu]: `${SpecKeys.CONTROL}+P`,
        [SaveMenuShortcutsKeyName.saveLayout]: `${SpecKeys.META}+S`
    },
    [ShortcutsCategories.CHART_DURATION]: {
        [ChartDurationShortcutKeyName.openChartDuration]: `${SpecKeys.ALT}+G`
    },
    [ShortcutsCategories.CHART]: {
        [ChartShortcutsKeyName.showHideFullScreen]: `${SpecKeys.SHIFT}+F`,
        [ChartShortcutsKeyName.resetChartView]: `${SpecKeys.ALT}+R`,
        [ChartShortcutsKeyName.showPlusButtonOnCursor]: `${SpecKeys.ALT}+${SpecKeys.META}`,
        [ChartShortcutsKeyName.scrollToRecentBar]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowRight}`,
    },
    [ShortcutsCategories.SECURITY_SEARCH]:{[SecritySearchShortcuts.securitySearch]:`${SpecKeys.SHIFT}+C`},
    [ShortcutsCategories.QUICK_SEARCH]:{[SecritySearchShortcuts.quickSearch]:`${SpecKeys.META}+K`},

    [ShortcutsCategories.CUSTOM_TIME_INTERVAL]: {
        [CustomTimeBucketShortcutsKeyName.openCustomTimeBucketIntervalDialog]: `,`
    },
    [ShortcutsCategories.ADD_TO_WATCHLIST]: {
        [WatchlistShortcutsKeyName.addToWatchlist]: `${SpecKeys.ALT}+W`
    },
    [ShortcutsCategories.CHART_REPLAY]: {
        [ChartReplayShortcutsKeyName.openCloseChartReplayDialog]: `${SpecKeys.SHIFT}+R`
    },
    [ShortcutsCategories.CHART_TYPE]: {
        [ChartTypeShortcutsKeyName.openChartTypeMenu]: `${SpecKeys.ALT}+T`
    },
    [ShortcutsCategories.SCREENER]: {
        [ScreenerScreenMenuShortcutsKeyName.createNewScreen]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+N`,
        [ScreenerScreenMenuShortcutsKeyName.saveScreen]: `${SpecKeys.META}+S`,
        [ScreenerScreenMenuShortcutsKeyName.saveAsScreen]: `${SpecKeys.META}+${SpecKeys.SHIFT}+S`,
        [ScreenerScreenMenuShortcutsKeyName.discardScreenChanges]: `${SpecKeys.ALT}+D`,
        [ScreenerScreenMenuShortcutsKeyName.exportScreen]: `${SpecKeys.ALT}+E`,
        [ScreenerScreenMenuShortcutsKeyName.renameScreen]: `${SpecKeys.ALT}+R`
    },
    [ShortcutsCategories.CHART_SETTINGS]: {
        [ChartSettingsShortcutsKeyName.zoomIn]: `${SpecKeys.META}+${KeyCodeToKey.ArrowUp}`,
        [ChartSettingsShortcutsKeyName.zoomOut]: `${SpecKeys.META}+${KeyCodeToKey.ArrowDown}`,
        [ChartSettingsShortcutsKeyName.moveChartLeft]: `${KeyCodeToKey.ArrowLeft}`,
        [ChartSettingsShortcutsKeyName.moveChartRight]: `${KeyCodeToKey.ArrowRight}`,
        [ChartSettingsShortcutsKeyName.splitVertical]: `${SpecKeys.META}+V`,
        [ChartSettingsShortcutsKeyName.splitHorizontal]: `${SpecKeys.META}+H`,
        [ChartSettingsShortcutsKeyName.deleteCurrentWidget]: `${SpecKeys.META}+${KeyCodeToKey.Backspace || KeyCodeToKey.Delete}`
    },
    [ShortcutsCategories.QUICK_WIDGETS]: {
        [QuickWidgetShortcutsKeyName.showHideQuickWidgets]: `${SpecKeys.SHIFT}+Q`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetMarketDepth]: `${SpecKeys.SHIFT}+D`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetOrders]: `${SpecKeys.SHIFT}+O`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetPositions]: `${SpecKeys.SHIFT}+P`,
        [QuickWidgetShortcutsKeyName.openQuickTradeWidget]: `${SpecKeys.SHIFT}+T`
    }
}

export const windowsShortcuts: Record<string, ShortcutKeyMap> = {
    [ShortcutsCategories.GLOBAL]: {
        // [GlobalShortcutsKeyName.openCloseTradePanel]: `${SpecKeys.SHIFT}+T`,
        [GlobalShortcutsKeyName.placeMarketOrderBuy]: `${SpecKeys.SHIFT}+B`,
        [GlobalShortcutsKeyName.placeMarketOrderSell]: `${SpecKeys.SHIFT}+S`,
        [GlobalShortcutsKeyName.placeLimitOrderBuy]: `${SpecKeys.SHIFT}+${SpecKeys.ALT}+B`,
        [GlobalShortcutsKeyName.placeLimitOrderSell]: `${SpecKeys.SHIFT}+${SpecKeys.ALT}+S`
    },
    [ShortcutsCategories.ALERT_DIALOG]: {
        [AlertDialogShortcutsKeyName.openAlertDialog]: `${SpecKeys.ALT}+A`
    },
    [ShortcutsCategories.INDICATOR_DIALOG]: {
        [IndicatorDialogShortcutsKeyName.openIndicatorDialog]: '/'
    },
    [ShortcutsCategories.MULTI_PANE_MENU]: {
        [MultiPaneMenuShortcutsKeyName.openMultiPaneMenu]: '.',
        [MultiPaneMenuShortcutsKeyName.saveLayout]: `${SpecKeys.CONTROL}+S`
    },
    [ShortcutsCategories.SAVE_MENU]: {
        [SaveMenuShortcutsKeyName.openSaveMenu]: `${SpecKeys.CONTROL}+P`,
        [SaveMenuShortcutsKeyName.saveLayout]: `${SpecKeys.META}+S`
    },
    [ShortcutsCategories.CHART]: {
        [ChartShortcutsKeyName.showHideFullScreen]: `${SpecKeys.SHIFT}+F`,
        [ChartShortcutsKeyName.resetChartView]: `${SpecKeys.ALT}+R`,
        [ChartShortcutsKeyName.showPlusButtonOnCursor]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}`,
        [ChartShortcutsKeyName.scrollToRecentBar]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowRight}`,
    },
    [ShortcutsCategories.CHART_DURATION]: {
        [ChartDurationShortcutKeyName.openChartDuration]: `${SpecKeys.ALT}+G`
    },
    [ShortcutsCategories.SECURITY_SEARCH]: {},
    [ShortcutsCategories.QUICK_SEARCH]:{[SecritySearchShortcuts.quickSearch]:`${SpecKeys.META}+K`},
    [ShortcutsCategories.CUSTOM_TIME_INTERVAL]: {
        [CustomTimeBucketShortcutsKeyName.openCustomTimeBucketIntervalDialog]: `,`
    },
    [ShortcutsCategories.ADD_TO_WATCHLIST]: {
        [WatchlistShortcutsKeyName.addToWatchlist]: `${SpecKeys.ALT}+W`
    },
    [ShortcutsCategories.CHART_REPLAY]: {
        [ChartReplayShortcutsKeyName.openCloseChartReplayDialog]: `${SpecKeys.SHIFT}+R`
    },
    [ShortcutsCategories.CHART_TYPE]: {
        [ChartTypeShortcutsKeyName.openChartTypeMenu]: `${SpecKeys.ALT}+T`
    },
    [ShortcutsCategories.SCREENER]: {
        [ScreenerScreenMenuShortcutsKeyName.createNewScreen]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+N`,
        [ScreenerScreenMenuShortcutsKeyName.saveScreen]: `${SpecKeys.META}+S`,
        [ScreenerScreenMenuShortcutsKeyName.saveAsScreen]: `${SpecKeys.META}+${SpecKeys.SHIFT}+S`,
        [ScreenerScreenMenuShortcutsKeyName.discardScreenChanges]: `${SpecKeys.ALT}+D`,
        [ScreenerScreenMenuShortcutsKeyName.exportScreen]: `${SpecKeys.ALT}+E`,
        [ScreenerScreenMenuShortcutsKeyName.renameScreen]: `${SpecKeys.ALT}+R`
    },
    [ShortcutsCategories.CHART_SETTINGS]: {
        [ChartSettingsShortcutsKeyName.zoomIn]: `${SpecKeys.META}+${KeyCodeToKey.ArrowUp}`,
        [ChartSettingsShortcutsKeyName.zoomOut]: `${SpecKeys.META}+${KeyCodeToKey.ArrowDown}`,
        [ChartSettingsShortcutsKeyName.moveChartLeft]: `${KeyCodeToKey.ArrowLeft}`,
        [ChartSettingsShortcutsKeyName.moveChartRight]: `${KeyCodeToKey.ArrowRight}`,
        [ChartSettingsShortcutsKeyName.splitVertical]: `${SpecKeys.META}+V`,
        [ChartSettingsShortcutsKeyName.splitHorizontal]: `${SpecKeys.META}+H`,
        [ChartSettingsShortcutsKeyName.deleteCurrentWidget]: `${SpecKeys.META}+${KeyCodeToKey.Backspace || KeyCodeToKey.Delete}`
    },
    [ShortcutsCategories.QUICK_WIDGETS]: {
        [QuickWidgetShortcutsKeyName.showHideQuickWidgets]: `${SpecKeys.SHIFT}+Q`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetMarketDepth]: `${SpecKeys.SHIFT}+D`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetOrders]: `${SpecKeys.SHIFT}+O`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetPositions]: `${SpecKeys.SHIFT}+P`,
        [QuickWidgetShortcutsKeyName.openQuickTradeWidget]: `${SpecKeys.SHIFT}+T`,
    }
}